import { createFileRoute } from "@tanstack/react-router";
import { SpokePage, buildSpokeHead, type SpokePageConfig } from "@/components/SpokePage";

const CONFIG: SpokePageConfig = {
  slug: "hire-a-website-designer-colorado",
  metaTitle: "Hire a Website Designer in Colorado | Flat-Rate Small Business Sites",
  metaDescription: "Hire a Colorado website designer for your small business. Flat-rate websites from $1,850 with one year of hosting, typically ready in under 7 business days.",
  breadcrumbs: [{ label: "Home", to: "/" }],
  currentLabel: "Hire a Website Designer",
  eyebrow: "Website Designers for Small Business — Colorado",
  h1: (
    <>
      Hire a <span className="text-brand-gold">Website Designer</span> in Colorado
    </>
  ),
  heroDescription: "Owner-led website design for Colorado small businesses. Flat rates, real people, and sites built to bring in calls.",
  intro: "Looking for website developers near you? We design fast, mobile-friendly websites for Colorado small businesses, from contractors to dental offices. You talk directly to the owner, pay a flat rate, and own a site built to show up on Google.",
  definition: { term: "Website designer for small business", body: "A designer who plans, builds and launches your business website, with pages for each service and town you serve, so customers can find you and call." },
  whatWeDo: [
    { title: "Flat-rate packages", body: "$1,850, $2,750 or $5,950 one-time, each with one year of hosting." },
    { title: "Fast turnaround", body: "Typical sites are ready in under seven business days." },
    { title: "A page per service", body: "Every service gets its own page so it can show up in search." },
    { title: "Built for phones", body: "Call and quote buttons that work with one thumb." },
    { title: "SEO-ready", body: "Clean structure and local business details from day one." },
    { title: "Free mockup first", body: "See your homepage design before you commit." },
  ],
  whyThisMarket: [
    { heading: "Local beats generic", body: "Colorado customers search by town. Pages for the towns you serve bring nearby calls." },
    { heading: "Speed matters", body: "Slow sites lose visitors before they ever see your phone number." },
    { heading: "Talk to the owner", body: "You work directly with Chris, not a rotating account team." },
  ],
  relatedLinks: [
    { to: "/pricing", label: "Pricing" },
    { to: "/free-mockup", label: "Get a free website mockup" },
    { to: "/free-audit", label: "Get a free marketing audit" },
    { to: "/web-design-castle-rock-colorado", label: "Castle Rock web design company" },
    { to: "/case-studies", label: "Colorado case studies" },
    { to: "/learn", label: "Learn hub" },
  ],
  faqs: [
    { q: "How much does it cost?", a: "Websites start at $1,850 one-time with one year of hosting. Monthly marketing starts at $950/month. Edits and repairs are $250/hour." },
    { q: "Do you only work in Colorado?", a: "Yes. We work with Colorado businesses, from Colorado Springs and Castle Rock to Denver, Fort Collins and Pueblo." },
    { q: "Can I see something before I commit?", a: "Yes. Request a free website mockup or a free marketing audit." },
  ],
  serviceName: "Small Business Website Design in Colorado",
  serviceDescription: "Hire a Colorado website designer for your small business. Flat-rate websites from $1,850 with one year of hosting, typically ready in under 7 business days.",
  areaServed: "Colorado",
};

export const Route = createFileRoute("/hire-a-website-designer-colorado")({
  head: () => buildSpokeHead(CONFIG),
  component: () => <SpokePage config={CONFIG} />,
});
